export enum ConfigMeta {
  OEL_PAAS_API_URL = 'oel-paas-api-url',
  OEL_URL_RETOUR_EXTERNE = 'oel-url-retour-externe',
  OEL_URL_PLANIFIER_APPEL = 'oel-url-planifier-appel',
}
